<template>
    <div class="dm-manuscript-single-illustration">
        <img :src="illustration.thumb_url" @click="showFullImage()" />

        <button
            class="btn btn-sm btn-icon btn-light-danger dm-delete-illustration"
            @click="deleteIllustration()"
        >
            <i class="icon-lg las la-times"></i>
        </button>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState } from "pinia";

export default {
    props: ["illustration"],

    computed: {
        ...mapState(useSubmissionWizardStore, ["presentation"]),
    },

    methods: {
        showFullImage() {
            this.$swal({
                html: "<img src='" + this.illustration.full_url + "'>",
                confirmButtonText: "Close",
                didOpen: function (dObj) {
                    $(".swal2-popup").css("width", "52em");
                    $(".swal2-container .swal2-html-container").css(
                        "max-height",
                        "none",
                    );
                },
                content: true,
                animation: false,
            });
        },

        deleteIllustration(illustrationId) {
            var self = this;
            axios
                .delete(
                    "/api/author/presentations/" +
                        this.illustration.presentation_id +
                        "/illustrations/" +
                        this.illustration.id,
                )
                .then(function (response) {
                    self.presentation.illustrations =
                        response.data.illustrations;
                    self.showSwalSuccessPopup();
                });
        },
    },
};
</script>
